import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

export interface ActionBarButton {
  action?: () => void | Promise<void>;
  disabled?: () => boolean;
  icon?: string;
  label: string;
  newTab?: boolean;
  primary?: boolean;
  routerLink?: string | string[];
  queryParams?: NavigationExtras;
  tooltip?: string;
}

export interface ActionBarMenuItem {
  action?: () => void;
  label: string;
  newTab?: boolean;
  routerLink?: string | string[];
  queryParams?: NavigationExtras;
}

export interface ActionBar {
  buttons?: ActionBarButton[];
  menu?: ActionBarMenuItem[];
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-action-bar',
  styleUrls: ['./action-bar.component.scss'],
  templateUrl: './action-bar.component.html'
})
export class ActionBarComponent implements OnInit {
  @Input() actionBar: ActionBar;

  constructor(private router: Router) {}

  ngOnInit() {}

  // Necessary implementation due to how it works in conjunction with form builder
  isButtonDisabled(button: ActionBarButton): boolean {
    return button.disabled && button.disabled();
  }

  navigateTo(actionBarObject: ActionBarMenuItem | ActionBarButton): void {
    let routerUrlTree = actionBarObject.routerLink;
    if (typeof routerUrlTree == 'string') routerUrlTree = [routerUrlTree];

    if (actionBarObject.newTab) {
      let urlTree = this.router.createUrlTree(routerUrlTree);
      if (actionBarObject.queryParams) urlTree.queryParams = actionBarObject.queryParams;
      let url = this.router.serializeUrl(urlTree);

      window.open(url, '_blank');
    } else {
      void this.router.navigate(routerUrlTree, actionBarObject.queryParams);
    }
  }
}
